import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import {  getMechanicsURL } from '../utils/api';

const useGetMechanics = ({ 
        page = 1,
        limit = 3000,
        keyword, 
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingMechanics, setGettingMechanics ] = useState(false);
    const [ mechanics, setMechanics ] = useState([]);
    const [ totalMechanics, setTotalMechanics ] = useState(0);
    const [ gettingMechanicsReqSuccess, setGettingMechanicsReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingMechanics) {
            axios.get(getMechanicsURL,
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    page,
                    limit,
                    keyword, 
                }
            }).then(result => {
                setGettingMechanics(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalMechanics(result.data.total);
                    }
                    setGettingMechanicsReqSuccess(true);
                    setMechanics(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingMechanicsReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingMechanicsReqSuccess(false);
                setGettingMechanics(false);
            });
        }
    }, [gettingMechanics]);

    return { mechanics, totalMechanics, gettingMechanics, setGettingMechanics, gettingMechanicsReqSuccess };
}

export default useGetMechanics;